module.exports = __webpack_public_path__ + "img/step2.116f6ef0.png";